import { Component, OnInit } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {UptimeRobotService} from '../../services/uptime-robot-service';
import {UptimeRobotMonitor, UptimeRobotMonitorStatus} from '../../models/uptime-robot.model';
import {WhmcsService} from '../../services/whmcs-service';
import {WhmcsStats} from '../../models/whmcs-stats.model';
import {StripeService} from '../../services/stripe-service';
import {StripePayout} from '../../models/stripe.model';
import {WccService} from '../../services/wcc-service';
import {Website} from '../../models/website.model';

@Component({
  selector: 'app-streamup-under-development',
  templateUrl: './under-development.component.html',
  styleUrls: ['./under-development.component.scss']
})
export class UnderDevelopmentComponent {

  constructor() { }

}
